
import styled from "styled-components";

export const getResponsiveStyle = (props: any, key: string, fallback: string = '') => {
  return props?.component_styles?.mobile?.[key]
    || props?.component_styles?.computer?.[key]
    || fallback;
}



export const SearchBox = styled.p<any>`
  width: 100%;
  flex-direction: row;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 10px 0px;
  border-bottom: 2px solid #ddd;
  gap: 10px;

  flex-wrap: wrap;
`;


export const SearchContainer = styled.p<any>`
width: auto;
  font-size: ${props => props?.component_styles?.computer?.search_size || '14px'} !important;
  line-height: ${props => props?.component_styles?.computer?.search_line_height || '18px'} !important;
  background: ${props => props?.component_styles?.computer?.search_background || 'none'} !important;  
  color: ${props => props?.component_styles?.computer?.search_color || '#333'} !important; 
  text-align: ${props => props?.component_styles?.computer?.search_text_align || 'left'} !important; 
  padding: ${props => props?.component_styles?.computer?.search_padding || '10px 0px'} !important; 

  p{
  font-size: 12px;
  color: #777;
  }

  input,select {
  min-height : 48px;
  padding: 10px 16px;
  border-radius: 5px;
  max-width: 300px;
  }

  button{
   min-height : 48px;
   width:  48px;
   height:  48px;
   margin: 0px !important;

   svg{
   font-size: 30px;
   min-width: 30px;
   }
  }


  @media (max-width: 750px) {
    font-size: ${props => getResponsiveStyle(props, 'search_size', '14px')} !important;
    line-height: ${props => getResponsiveStyle(props, 'search_line_height', '18px')} !important;
    background: ${props => getResponsiveStyle(props, 'search_background', 'none')} !important;
    color: ${props => getResponsiveStyle(props, 'search_color', '#333')} !important;
    text-align: ${props => getResponsiveStyle(props, 'search_text_align', 'left')} !important;
    padding: ${props => getResponsiveStyle(props, 'search_padding', '10px 0px')} !important;
  }
`;